<template>
    <div>
     <!-- Monetization -->
    <div class="border mb-2 rounded-lg font-weight-bold text-dark" v-if="monetization">
        <nav class="m-2">
            <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                <li class="nav-item has-treeview menu-close">
                    <a class="nav-link flex align-items-center text-success" style="cursor: pointer;">
                    <i class="nav-icon fas fa-dollar-sign"></i>
                    <div class=""> Monetization </div><i class="fas fa-angle-left ml-auto"></i> 
                    </a>
                    <ul class="m-3 nav nav-treeview">
                        <li class="nav-item py-4 font-weight-normal">
                            <div class="d-flex justify-content-start align-items-center">
                                <div class="col-md-6">
                                    Monetize 
                                </div>
                                <div class="col-md-6">
                                    <div class="inline">
                                        <div class="custom-control custom-switch p-0 py-2">
                                            <label class="switch" for="montize">
                                                <input type="checkbox" class="primary" id="montize" v-model="monetization.monetize">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>    
                        </li>
                        <li class="nav-item mb-4 font-weight-normal" style="display:none;">
                            <div class="d-flex justify-content-start align-items-center">
                                <div class="col-md-6 ">
                                    Disable player if ad blocker detected <i class="fas fa-question-circle"></i>
                                </div>
                                <div class="col-md-6">
                                    <div class="inline">
                                        <div class="custom-control custom-switch p-0 py-2">
                                            <label class="switch" for="disablePlayerAdBlock">
                                                <input type="checkbox" class="primary" id="disablePlayerAdBlock" v-model="monetization.disable_player_ad_block">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>    
                        </li>
                        <li class="nav-item mb-4 font-weight-normal" style="display:none;">
                            <div class="d-flex justify-content-start align-items-center">
                                <div class="col-md-6 ">
                                    Disable autoplay if ad blocker detected <i class="fas fa-question-circle"></i>
                                </div>
                                <div class="col-md-6">
                                    <div class="inline">
                                        <div class="custom-control custom-switch p-0 py-2">
                                            <label class="switch" for="disableAutoPlayAdBlock">
                                                <input type="checkbox" class="primary" id="disableAutoPlayAdBlock" v-model="monetization.disable_autoplay_ad_block">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>    
                        </li>
                        <li class="nav-item py-4 font-weight-normal">
                            <div class="d-flex justify-content-start">

                                 <select class="form-control" v-model="monetization.schedule.type">
                                    <option value="vmap">VMAP</option>
                                    <option value="vast" selected>VAST</option>
                                    <option value="multiple_vast">Multiple VAST</option>
                                </select>
            
                                <button type="button" class="btn btn-primary mx-2" 
                                v-if="monetization.schedule.type === 'vmap'"
                                @click.prevent="isPreroll = true"
                                :class="{'btn-light' : isPreroll}"> Preroll </button>

                                <button type="button"  class="btn btn-secondary mx-2"
                                v-if="monetization.schedule.type === 'vmap'" 
                                @click.prevent="isMidroll = true" 
                                :class="{'btn-light' : isMidroll}"> Midroll </button>

                                <button type="button" class="btn btn-success mx-2"
                                v-if="monetization.schedule.type === 'vmap'" 
                                @click.prevent="isPostroll = true"
                                :class="{'btn-light' : isPostroll}"> Postroll </button>

                                <button type="button" class="btn btn-danger mx-2"
                                v-if="monetization.schedule.type === 'vast'" 
                                @click.prevent="isVast = true"
                                :class="{'btn-light' : isVast}"> Vast </button>

                                <button type="button" class="btn btn-danger mx-2"
                                v-if="monetization.schedule.type === 'multiple_vast'" 
                                @click.prevent="isMultipleVast = true"
                                :class="{'btn-light' : isMultipleVast}"> Multiple Vast </button>

                                <button type="button" class="btn btn-danger mx-2" 
                                @click.prevent="isDisplayBanner = true"
                                :class="{'btn-light' : isDisplayBanner}"> Display Banner </button>
                            </div>
                        </li>

                        <li class="nav-item mb-2 font-weight-normal" v-if="adcrew_settings">
                            <div class="border rounded p-3 mb-3">
                                <h6 class="font-weight-bold mb-2">
                                    <i class="fas fa-window-maximize mr-1"></i> Non-Linear Ads
                                </h6>
                                <div class="d-flex justify-content-start align-items-center">
                                    <div class="col-md-8 px-0">
                                        Disable non-linear / overlay creatives
                                        <div class="text-muted font-weight-normal" style="font-size: 0.85em;">
                                            Enabled by default. When on, the player only requests linear video ads and tells IMA to reject non-linear creatives.
                                        </div>
                                    </div>
                                    <div class="col-md-4 d-flex justify-content-end px-0">
                                        <div class="custom-control custom-switch p-0 py-2">
                                            <label class="switch" for="disable_non_linear">
                                                <input type="checkbox" class="primary" id="disable_non_linear" v-model="adcrew_settings.disable_non_linear">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>

                        <li class="nav-item mb-2 font-weight-normal" v-if="adcrew_settings">
                            <div class="border rounded p-3 mb-3">
                                <h6 class="font-weight-bold mb-2">
                                    <i class="fas fa-expand mr-1"></i> Full-Slot Ad Mode
                                </h6>
                                <div class="d-flex justify-content-start align-items-center">
                                    <div class="col-md-8 px-0" style="min-width: 0; flex: 1;">
                                        Hide player chrome during linear ads
                                        <div class="text-muted font-weight-normal" style="font-size: 0.85em;">
                                            Off by default. When on, the player hides its controls and title during linear ads so IMA's skip button and countdown get the full slot.
                                        </div>
                                    </div>
                                    <div class="col-md-4 d-flex justify-content-end px-0">
                                        <div class="custom-control custom-switch p-0 py-2">
                                            <label class="switch" for="full_slot_ad_mode">
                                                <input type="checkbox" class="primary" id="full_slot_ad_mode" v-model="adcrew_settings.full_slot_ad_mode">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>

                        <li v-if="isPreroll || monetization.schedule.preroll.length > 0" >
                            <Schedule 
                            :schedules=monetization.schedule.preroll
                            schedule_type="preroll"
                            @delete=onScheduleDelete
                            @changed=onScheduleChanged />
                        </li>

                        <li v-if="isMidroll || monetization.schedule.midroll.length > 0" >
                            <Schedule 
                            :schedules=monetization.schedule.midroll
                            schedule_type="midroll"
                            @delete=onScheduleDelete
                            @changed=onScheduleChanged />
                        </li>

                        <li v-if="isPostroll || monetization.schedule.postroll.length > 0" >
                            <Schedule 
                            :schedules=monetization.schedule.postroll
                            schedule_type="postroll"
                            @delete=onScheduleDelete
                            @changed=onScheduleChanged />
                        </li>

                        <li v-if="isDisplayBanner || monetization.schedule.display_banner != null" >
                            <Schedule 
                            :schedules=monetization.schedule.display_banner
                            schedule_type="display_banner"
                            @delete=onScheduleDelete
                            @changed=onScheduleChanged />
                        </li>

                        <li v-if="isVast || monetization.schedule.vast != null" >
                            <Schedule 
                            :schedules=monetization.schedule.vast
                            schedule_type="vast"
                            @delete=onScheduleDelete
                            @changed=onScheduleChanged />
                        </li>

                        <li v-if="isMultipleVast || monetization.schedule.multiple_vast.length > 0" >
                            <Schedule 
                            :schedules=monetization.schedule.multiple_vast
                            schedule_type="multiple_vast"
                            @delete=onScheduleDelete
                            @changed=onScheduleChanged />
                        </li>

                        <!-- Ad Sources: which demand the player asks, and in what order.
                             Not "Ad Request Mode" (AdCrew settings), which is break timing. -->
                        <li class="nav-item py-4 font-weight-normal">
                            <div class="border rounded p-3 mb-3">
                                <h6 class="font-weight-bold mb-2">Ad Sources</h6>
                                <div class="text-muted font-weight-normal mb-3" style="font-size: 0.85em;">
                                    Where the player asks for an ad, top first. The first source that returns an ad plays;
                                    a source with no ad falls through to the next. None selected keeps the default:
                                    header bidding when it is enabled, then the ad tag.
                                </div>
                                <div
                                    class="border rounded my-2 px-3 py-2 d-flex align-items-center"
                                    v-for="(source, index) in adSourceOrder"
                                    :key="source"
                                    draggable="true"
                                    @dragstart="draggedSourceIndex = index"
                                    @dragover.prevent
                                    @drop="dropAdSource(index)"
                                    style="cursor: move;"
                                >
                                    <i class="fas fa-grip-vertical mr-3 text-muted"></i>
                                    <div class="flex-grow-1">{{ adSourceLabels[source] }}</div>
                                    <label class="switch mb-0" :for="'adSource_' + source">
                                        <input type="checkbox" class="primary" :id="'adSource_' + source"
                                            :checked="adSources.includes(source)"
                                            @change="toggleAdSource(source, $event.target.checked)">
                                        <span class="slider round"></span>
                                    </label>
                                </div>
                                <div class="mt-3" v-if="adSources.includes('exchange')">
                                    <label class="font-weight-bold" for="exchangeTagId">Exchange Tag ID</label>
                                    <input id="exchangeTagId" type="text" class="form-control"
                                        v-model.trim="monetization.exchange_tag_id"
                                        placeholder="Exchange console: Inventory → the site → browser tag">
                                    <div class="text-muted font-weight-normal" style="font-size: 0.85em;">
                                        The tag only serves pages on the site it was issued for.
                                    </div>
                                </div>
                            </div>
                        </li>

                        <!-- Header Bidding Section -->
                        <li class="nav-item py-4 font-weight-normal">
                            <div class="border rounded p-3 mb-3">
                                <h6 class="font-weight-bold mb-3">Header Bidding</h6>
                                
                                <div class="d-flex justify-content-start align-items-center mb-3">
                                    <div class="col-md-6">
                                        Enable Header Bidding
                                    </div>
                                    <div class="col-md-6">
                                        <div class="inline">
                                            <div class="custom-control custom-switch p-0 py-2">
                                                <label class="switch" for="headerBiddingEnabled">
                                                    <input type="checkbox" class="primary" id="headerBiddingEnabled" 
                                                        :checked="header_bidding && header_bidding.enabled" 
                                                        @change="toggleHeaderBidding($event)">
                                                    <span class="slider round"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="header_bidding && header_bidding.enabled">
                                    <div class="d-flex justify-content-start align-items-center mb-3">
                                        <div class="col-md-6">
                                            Timeout (ms)
                                        </div>
                                        <div class="col-md-6">
                                            <input type="number" class="form-control" v-model.number="header_bidding.timeout" placeholder="3000">
                                        </div>
                                    </div>

                                    <div class="d-flex justify-content-start align-items-center mb-3">
                                        <div class="col-md-6">
                                            DFP Network ID
                                        </div>
                                        <div class="col-md-6">
                                            <input type="text" class="form-control" v-model="header_bidding.dfp_network_id" placeholder="Enter DFP Network ID">
                                        </div>
                                    </div>

                                    <div class="d-flex justify-content-start align-items-center mb-3">
                                        <div class="col-md-6">
                                            DFP Ad Unit
                                        </div>
                                        <div class="col-md-6">
                                            <input type="text" class="form-control" v-model="header_bidding.dfp_ad_unit" placeholder="video/preroll">
                                        </div>
                                    </div>

                                    <div class="d-flex justify-content-start align-items-center mb-3">
                                        <div class="col-md-6">
                                            PBS Account ID
                                            <div class="text-muted font-weight-normal" style="font-size: 0.8em;">Must match an account registered on the AdCrew Prebid Server.</div>
                                        </div>
                                        <div class="col-md-6">
                                            <input type="text" class="form-control" v-model="header_bidding.account_id" placeholder="1">
                                        </div>
                                    </div>

                                    <div class="d-flex justify-content-start align-items-center mb-3">
                                        <div class="col-md-6">
                                            Supply Chain Seller ID
                                            <div class="text-muted font-weight-normal" style="font-size: 0.8em;"><code>seller_id</code> from adcrew.co/sellers.json. Blank = no schain — wrong is worse than none.</div>
                                        </div>
                                        <div class="col-md-6">
                                            <input type="text" class="form-control" v-model="header_bidding.schain_sid" placeholder="e.g. 69cd9b5eca45502f45866171">
                                        </div>
                                    </div>

                                    <div class="d-flex justify-content-start align-items-center mb-3">
                                        <div class="col-md-6">
                                            Prebid.js URL
                                            <div class="text-muted font-weight-normal" style="font-size: 0.8em;">Optional. Leave blank to use the default CDN build.</div>
                                        </div>
                                        <div class="col-md-6">
                                            <input type="text" class="form-control" v-model="header_bidding.prebid_url" placeholder="https://...">
                                        </div>
                                    </div>

                                    <div class="d-flex justify-content-start align-items-center mb-3">
                                        <div class="col-md-6">
                                            Price Granularity
                                        </div>
                                        <div class="col-md-6">
                                            <select class="form-control" v-model="header_bidding.price_granularity">
                                                <option value="low">Low</option>
                                                <option value="medium">Medium</option>
                                                <option value="high">High</option>
                                                <option value="dense">Dense</option>
                                                <option value="auto">Auto</option>
                                                <option value="custom">Custom</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="d-flex justify-content-start align-items-center mb-3">
                                        <div class="col-md-6">
                                            Bidder Debug
                                            <div class="text-muted font-weight-normal" style="font-size: 0.8em;">Sends <code>ext.prebid.debug</code> to bidders — Sparteo rejects it. Troubleshooting only.</div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="inline">
                                                <div class="custom-control custom-switch p-0 py-2">
                                                    <label class="switch" for="hb_debug">
                                                        <input type="checkbox" class="primary" id="hb_debug" v-model="header_bidding.debug">
                                                        <span class="slider round"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="d-flex justify-content-start align-items-start mb-3">
                                        <div class="col-md-6">
                                            Consent Management
                                            <div class="text-muted font-weight-normal" style="font-size: 0.8em;">Optional JSON. Passed to pbjs.setConfig({consentManagement}).</div>
                                        </div>
                                        <div class="col-md-6">
                                            <textarea class="form-control" rows="3" v-model="consent_management_text" placeholder='{"gdpr":{"cmpApi":"iab","timeout":8000}}'></textarea>
                                        </div>
                                    </div>

                                    <div class="d-flex justify-content-start align-items-start mb-3">
                                        <div class="col-md-6">
                                            Custom Targeting
                                            <div class="text-muted font-weight-normal" style="font-size: 0.8em;">Optional JSON. Additional ad-server key-values.</div>
                                        </div>
                                        <div class="col-md-6">
                                            <textarea class="form-control" rows="3" v-model="custom_targeting_text" placeholder='{"section":"home","tier":"premium"}'></textarea>
                                        </div>
                                    </div>

                                    <!-- Bidders Section -->
                                    <div class="border p-3 w-100 relative">
                                        <!-- Selected bidders list -->
                                        <div class="w-100 scrollable-tags-list">
                                            <div 
                                                class="border bg-secondary bg-gradient my-2 px-4 py-2 d-flex rounded-md align-items-center" 
                                                v-for="(bidder, index) in header_bidding.bidders" 
                                                :key="index"
                                                draggable="true"
                                                @dragstart="dragStartBidder(index)"
                                                @dragover.prevent
                                                @drop="dropBidder(index)"
                                                style="cursor: move;"
                                            >
                                                <i class="fas fa-grip-vertical mr-3 text-muted"></i>
                                                <h5 class="mb-0">{{ bidder.name || bidder.adapter_type || 'New Bidder' }}</h5>
                                                <span class="badge badge-dark ml-2">{{ bidder.adapter_type || bidder.name }}</span>
                                                <span class="badge badge-primary ml-2">{{ index + 1 }}</span>
                                                <span class="badge badge-info ml-2">{{ bidderParamValue(bidder) }}</span>
                                                <span class="badge ml-2" :class="bidder.is_s2s === false ? 'badge-warning' : 'badge-success'">
                                                    {{ bidder.is_s2s === false ? 'Client-side' : 'Server-side' }}
                                                </span>
                                                <a href="#" @click.prevent="editBidder(index)" class="ml-auto mr-3"><i class="fas fa-pencil-alt"></i></a>
                                                <a href="#" @click.prevent="removeBidder(index)" class="text-danger"><i class="fas fa-times"></i></a>
                                            </div>
                                        </div>

                                        <input type="search" v-model="bidder_search" 
                                            placeholder="Select or add new bidder" 
                                            class="form-control dropdown-toggle mt-2" 
                                            data-toggle="dropdown" 
                                            aria-haspopup="false" 
                                            aria-expanded="false">
                                        
                                        <div class="dropdown-menu w-100 scrollable-dropdown">
                                            <a class="dropdown-item bg-secondary bg-gradient sticky-header" href="#" @click.prevent="showBidderModal()">ADD NEW BIDDER</a>
                                            <div class="dropdown-item d-flex align-items-center" v-for="bidderOption in filteredBidderOptions" :key="bidderOption.id">
                                                <a class="nav-icon" @click.prevent="selectBidder(bidderOption)" href="#">{{ bidderOption.name }}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <!-- Header Bidding Section End -->

                        <li>
                            <hr><br>
                            <button class="btn btn-success float-right" @click.prevent="update()">Save</button>
                            <br>
                        </li>
                    </ul>
                </li>
            </ul>
        </nav>
    </div>
    <!-- Monetization -->

    <!-- Bidder Modal -->
    <div class="modal fade" id="BidderModal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-body container">
                    <h1 class="text-xl">
                        <span v-if="editingBidderIndex !== null">UPDATE</span> <span v-else>ADD</span> BIDDER
                        <i @click="closeBidderModal()" data-dismiss="modal" class="fas fa-times float-right cursor-pointer"></i>
                    </h1>
                    
                    <hr class="my-3">
                    <div class="row">
                        <div class="form-group col-md-12">
                            <label>Adapter Type</label>
                            <select v-model="currentBidder.adapter_type" class="form-control border-top-0 border-right-0 border-left-0">
                                <option value="" disabled>Select a bidder…</option>
                                <option v-for="code in adapterTypeOptions" :key="code" :value="code">{{ code }}</option>
                            </select>
                            <small class="text-muted d-block mt-1">The Prebid bidder code the player loads. Pick from the supported bidders.</small>
                        </div>
                        <div class="form-group col-md-12">
                            <label>Name</label>
                            <input v-model="currentBidder.name" type="text" class="form-control border-top-0 border-right-0 border-left-0" placeholder="Your label, e.g. Eskimi - AlAin">
                            <small class="text-muted d-block mt-1">Optional label to tell entries apart — not used by the player.</small>
                        </div>
                        <div class="form-group col-md-12">
                            <label>{{ paramSpec.label }}</label>
                            <input v-model="currentBidder.paramValue" type="text" class="form-control border-top-0 border-right-0 border-left-0" :placeholder="paramSpec.placeholder">
                            <small class="text-muted d-block mt-1">
                                Sent as <code>params.{{ paramSpec.key }}</code>.
                                <span v-if="paramSpec.key !== 'placementId'">
                                    <strong>{{ currentBidder.adapter_type }}</strong> requires this field name —
                                    Prebid Server rejects the whole auction if it is wrong or blank.
                                </span>
                            </small>
                        </div>
                        <div class="form-group col-md-12">
                            <label class="d-flex align-items-center">
                                <input type="checkbox" v-model="currentBidder.is_s2s"
                                    :disabled="isClientSideOnlyBidder(currentBidder.adapter_type)"
                                    class="mr-2">
                                Run server-side (Prebid Server)
                            </label>
                            <small class="text-muted d-block">
                                <span v-if="isClientSideOnlyBidder(currentBidder.adapter_type)">
                                    <strong>{{ currentBidder.adapter_type }}</strong> has no Prebid Server adapter — must run client-side.
                                </span>
                                <span v-else>
                                    Most SSPs run server-side via prebid.adcrew.co. Uncheck only if this bidder
                                    has no PBS adapter and must run client-side via its Prebid.js module.
                                </span>
                            </small>
                        </div>
                        <div class="form-group col-md-12">
                            <label class="d-flex align-items-center">
                                <input type="checkbox" v-model="currentBidder.test" class="mr-2">
                                Test mode (request a test bid)
                            </label>
                            <small class="text-muted d-block">
                                Sends <strong>test:1</strong> to the bidder so it returns a guaranteed test
                                ad — use to verify the integration end-to-end, then turn off in production.
                            </small>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="col-md-10">
                        <small v-if="editingBidderIndex !== null">
                            <a href="#" class="text-red float-left" @click.prevent="deleteBidder()">Delete</a>
                        </small>
                    </div>
                    <div class="col-md-2">
                        <button type="button" @click.prevent="saveBidder()" class="btn btn-primary btn-block">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Bidder Modal End -->
    </div>
</template>
<script>
import Schedule from './Schedule.vue'

// Bidders whose Prebid Server adapter requires a param OTHER than placementId.
// PBS validates imp.ext.prebid.bidder.<code> against static/bidder-params/<code>.json
// and answers a mismatch with HTTP 400 on the WHOLE auction — not just that
// bidder — so a wrong key here silently kills every other bidder's demand too.
// Verified against the schema: sparteo requires networkId.
// Anything absent from this map uses placementId, which is what every bidder
// configured before now uses. Do not change that default.
const BIDDER_PARAM = {
    sparteo: { key: 'networkId', label: 'Network ID', placeholder: 'e.g. eebac84d-72c3-48f6-b315-923a140094c3' }
}
const DEFAULT_PARAM = { key: 'placementId', label: 'Placement ID', placeholder: 'Enter placement ID' }

function paramSpecFor(code) {
    return BIDDER_PARAM[(code || '').toLowerCase()] || DEFAULT_PARAM
}

import { RepositoryFactory } from '@/services/repositories/PlayerAPI/RepositoryFactory'
const MonetizationRepo = RepositoryFactory.get('monetization')
const AdCrewSettingsRepo = RepositoryFactory.get('adcrew_settings')
const SchedulesRepo = RepositoryFactory.get('schedules')
const HeaderBiddingRepo = RepositoryFactory.get('headerbidding')
const BiddersRepo = RepositoryFactory.get('bidders')

export default {
    props: {
        monetization: {
            type: Object,
        },
        adcrew_settings: {
            type: Object,
        }
    },
    components: {
        Schedule
    },
    data() {
        return {
            isPreroll: false,
            isMidroll: false,
            isPostroll: false,
            isDisplayBanner: false,
            isVast: false,
            isMultipleVast: false,
            //schedule: {}
            // paramValue is the single form field; it is written to the key the
            // selected adapter actually requires (see BIDDER_PARAM) only on save.
            // Holding one scalar avoids Vue 2 reactivity gaps from swapping keys
            // on a nested object as the dropdown changes.
            currentBidder: { name: '', adapter_type: '', paramValue: '', is_s2s: true, test: false },
            // Bidders we've integrated (exact Prebid codes). The Adapter Type
            // dropdown is restricted to these so the code stays valid and uniform
            // with the player. Keep in sync with the player bundle / CLIENT_SIDE lists.
            supportedBidders: [
                'adf', 'admixer', 'adtelligent', 'adtrgtme', 'amx', 'aniview',
                'appnexus', 'bidmatic', 'eskimi', 'incrementx', 'insticator',
                'lemmaDigital', 'limelightDigital', 'mgid', 'ogury', 'onetag',
                'openx', 'pgamssp', 'pubmatic', 'richaudience', 'rubicon', 'seedtag',
                'smartadserver', 'smilewanted', 'sovrn', 'sparteo', 'sspBC',
                'trafficgate', 'triplelift'
            ],
            editingBidderIndex: null,
            draggedBidderIndex: null,
            // All three sources in display order; monetization.ad_sources is the
            // enabled ones, in this order. Values are the players API's.
            adSourceOrder: ['exchange', 'prebid', 'waterfall'],
            adSourceLabels: {
                exchange: 'AdCrew Exchange',
                prebid: 'Header Bidding (Prebid)',
                waterfall: 'Ad Tag (VAST / waterfall)'
            },
            draggedSourceIndex: null,
            bidder_search: '',
            bidderOptions: [],
            header_bidding: null,
            // Textarea string mirrors of header_bidding.{consent_management,custom_targeting}.
            // Kept separately so the user can type invalid JSON without us blanking
            // the underlying object; parsed back into the object on save.
            consent_management_text: '',
            custom_targeting_text: ''
        }
    },
    computed: {
        adSources() {
            return (this.monetization && this.monetization.ad_sources) || []
        },
        filteredBidderOptions() {
            const selectedNames = (this.header_bidding && this.header_bidding.bidders || []).map(b => b.name.toLowerCase())
            // The bidders API returns one row per player config, so the same name
            // appears many times. Dedupe by name (case-insensitive) so each bidder
            // shows once in the picker.
            const seen = new Set()
            return this.bidderOptions.filter(option => {
                const lower = (option.name || '').toLowerCase()
                const matchesSearch = !this.bidder_search || lower.includes(this.bidder_search.toLowerCase())
                const notSelected = !selectedNames.includes(lower)
                if (!matchesSearch || !notSelected || seen.has(lower)) return false
                seen.add(lower)
                return true
            })
        },
        // Adapter Type dropdown options: the supported codes, plus the current
        // value if it's a legacy/unknown code (so editing doesn't lose it).
        adapterTypeOptions() {
            const opts = this.supportedBidders.slice()
            const cur = this.currentBidder && this.currentBidder.adapter_type
            if (cur && !opts.includes(cur)) opts.unshift(cur)
            return opts
        },
        // Which param the selected adapter requires. Drives the field label and
        // the key written on save.
        paramSpec() {
            return paramSpecFor(this.currentBidder && this.currentBidder.adapter_type)
        }
    },
    created() {
        if (this.adcrew_settings && (this.adcrew_settings.disable_non_linear === undefined || this.adcrew_settings.disable_non_linear === null)) {
            this.$set(this.adcrew_settings, 'disable_non_linear', true)
        }
        if (this.adcrew_settings && (this.adcrew_settings.full_slot_ad_mode === undefined || this.adcrew_settings.full_slot_ad_mode === null)) {
            this.$set(this.adcrew_settings, 'full_slot_ad_mode', false)
        }
        this.initAdSources()
        this.loadHeaderBidding()
        this.loadBidderOptions()
    },
    methods: {
        initAdSources() {
            if (!this.monetization) return
            if (!Array.isArray(this.monetization.ad_sources)) {
                this.$set(this.monetization, 'ad_sources', [])
            }
            if (typeof this.monetization.exchange_tag_id !== 'string') {
                this.$set(this.monetization, 'exchange_tag_id', '')
            }
            const enabled = this.monetization.ad_sources
            this.adSourceOrder = [...enabled, ...['exchange', 'prebid', 'waterfall'].filter(s => !enabled.includes(s))]
        },
        toggleAdSource(source, on) {
            const enabled = this.adSources
            this.monetization.ad_sources = this.adSourceOrder.filter(s => s === source ? on : enabled.includes(s))
        },
        dropAdSource(dropIndex) {
            if (this.draggedSourceIndex === null || this.draggedSourceIndex === dropIndex) {
                return
            }
            const order = [...this.adSourceOrder]
            const [moved] = order.splice(this.draggedSourceIndex, 1)
            order.splice(dropIndex, 0, moved)
            this.adSourceOrder = order
            this.draggedSourceIndex = null
            const enabled = this.adSources
            this.monetization.ad_sources = order.filter(s => enabled.includes(s))
        },
        loadBidderOptions() {
            BiddersRepo.query({ limit: 1000 }).then(result => {
                this.bidderOptions = result.data.results || []
            }).catch(error => {
                console.log('Failed to load bidder options:', error)
            })
        },
        toggleHeaderBidding(event) {
            const isEnabled = event.target.checked
            if (isEnabled) {
                // Initialize header_bidding if null
                if (!this.header_bidding) {
                    this.header_bidding = {
                        id: null,
                        enabled: true,
                        timeout: 3000,
                        dfp_network_id: '',
                        dfp_ad_unit: '',
                        account_id: '1',
                        prebid_url: '',
                        schain_sid: '',
                        price_granularity: 'medium',
                        consent_management: null,
                        custom_targeting: null,
                        debug: false,
                        bidders: []
                    }
                } else {
                    this.header_bidding.enabled = true
                }
            } else {
                if (this.header_bidding) {
                    this.header_bidding.enabled = false
                }
            }
        },
        selectBidder(bidderOption) {
            if (!this.header_bidding) {
                this.header_bidding = {
                    id: null,
                    enabled: true,
                    timeout: 3000,
                    dfp_network_id: '',
                    dfp_ad_unit: '',
                    schain_sid: '',
                    debug: false,
                    bidders: []
                }
            }
            if (!this.header_bidding.bidders) {
                this.header_bidding.bidders = []
            }
            
            // Check if bidder already exists
            const alreadyExists = this.header_bidding.bidders.some(
                b => b.name.toLowerCase() === bidderOption.name.toLowerCase()
            )
            if (alreadyExists) {
                this.$notify({
                    group: 'ops',
                    type: 'warning',
                    title: 'Duplicate Bidder',
                    text: `${bidderOption.name} is already added.`
                })
                return
            }
            
            // Add bidder directly with its existing params
            this.header_bidding.bidders.push({
                name: bidderOption.name,
                adapter_type: bidderOption.adapter_type || bidderOption.name,
                params: bidderOption.params || { placementId: '' }
            })
            this.bidder_search = ''
            
            // Save to API immediately
            this.updateHeaderBidding()
        },
        dragStartBidder(index) {
            this.draggedBidderIndex = index
        },
        dropBidder(dropIndex) {
            if (this.draggedBidderIndex === null || this.draggedBidderIndex === dropIndex) {
                return
            }

            // Reorder the array
            const draggedItem = this.header_bidding.bidders[this.draggedBidderIndex]
            const newArray = [...this.header_bidding.bidders]
            
            // Remove from old position
            newArray.splice(this.draggedBidderIndex, 1)
            
            // Insert at new position
            newArray.splice(dropIndex, 0, draggedItem)
            
            this.header_bidding.bidders = newArray
            this.draggedBidderIndex = null
            
            // Save order to API
            this.updateHeaderBidding()
        },
        loadHeaderBidding() {
            if (!this.monetization || !this.monetization.player) {
                console.log('loadHeaderBidding: monetization or player not available')
                return
            }
            
            console.log('loadHeaderBidding: fetching for player', this.monetization.player)
            HeaderBiddingRepo.getByPlayer(this.monetization.player).then(result => {
                console.log('loadHeaderBidding: response', result.data)
                if (result.data.results && result.data.results.length > 0) {
                    this.header_bidding = result.data.results[0]
                    // Ensure bidders array exists
                    if (!this.header_bidding.bidders) {
                        this.header_bidding.bidders = []
                    }
                    // Default values for fields that may not be present on legacy rows
                    if (this.header_bidding.account_id == null) this.$set(this.header_bidding, 'account_id', '1')
                    if (this.header_bidding.prebid_url == null) this.$set(this.header_bidding, 'prebid_url', '')
                    if (!this.header_bidding.price_granularity) this.$set(this.header_bidding, 'price_granularity', 'medium')
                    // Mirror JSON fields into the textarea-bound strings
                    this.consent_management_text = this.header_bidding.consent_management
                        ? JSON.stringify(this.header_bidding.consent_management, null, 2) : ''
                    this.custom_targeting_text = this.header_bidding.custom_targeting
                        ? JSON.stringify(this.header_bidding.custom_targeting, null, 2) : ''
                    console.log('loadHeaderBidding: loaded', this.header_bidding)
                } else {
                    // No header bidding exists for this player
                    this.header_bidding = null
                    this.consent_management_text = ''
                    this.custom_targeting_text = ''
                }
            }).catch(error => {
                console.log('loadHeaderBidding: error', error)
                this.header_bidding = null
            })
        },
        showBidderModal() {
            // Initialize header_bidding if null
            if (!this.header_bidding) {
                this.header_bidding = {
                    id: null,
                    enabled: true,
                    timeout: 3000,
                    dfp_network_id: '',
                    dfp_ad_unit: '',
                    bidders: []
                }
            }
            this.currentBidder = { name: '', adapter_type: '', paramValue: '', is_s2s: true, test: false }
            this.editingBidderIndex = null
            $('#BidderModal').modal('show')
        },
        editBidder(index) {
            const bidder = this.header_bidding.bidders[index]
            const code = bidder.adapter_type || bidder.name
            const p = bidder.params || {}
            // Read the adapter's own key first, then fall back to placementId so a
            // row saved before this map existed still opens with its value intact.
            const stored = p[paramSpecFor(code).key]
            this.currentBidder = {
                name: bidder.name,
                adapter_type: code,
                paramValue: (stored !== undefined && stored !== null) ? stored : (p.placementId || ''),
                // Backwards-compat: rows from before this field existed default to S2S.
                is_s2s: bidder.is_s2s !== false,
                test: !!p.test
            }
            // Force client-side for known no-PBS-adapter bidders regardless of stored value
            if (this.isClientSideOnlyBidder(this.currentBidder.adapter_type)) {
                this.currentBidder.is_s2s = false
            }
            this.editingBidderIndex = index
            $('#BidderModal').modal('show')
        },
        // The id shown on a bidder row — read under whichever key that adapter
        // uses, so sparteo's networkId shows instead of a blank badge.
        bidderParamValue(bidder) {
            const p = (bidder && bidder.params) || {}
            const v = p[paramSpecFor(bidder && (bidder.adapter_type || bidder.name)).key]
            return (v !== undefined && v !== null && v !== '') ? v : (p.placementId || '')
        },
        // Keep this list in sync with CLIENT_SIDE_ONLY_BIDDERS in the player wrapper
        // (src/services/HeaderBidding/PrebidWrapper.js) and in the players backend
        // (configurations/constants.py, enforced by the serializer). Names are
        // lowercased before comparison.
        isClientSideOnlyBidder(name) {
            const CLIENT_SIDE_ONLY = [
                'adf', 'admixer', 'adtelligent', 'adtrgtme', 'amx', 'aniview',
                'appnexus', 'bidmatic', 'incrementx', 'insticator', 'lemmadigital',
                'limelightdigital', 'mgid', 'ogury', 'onetag', 'openx', 'pgamssp',
                'pubmatic', 'richaudience', 'rubicon', 'seedtag', 'smartadserver',
                'smilewanted', 'sovrn', 'sspbc', 'trafficgate', 'triplelift'
            ]
            return CLIENT_SIDE_ONLY.includes((name || '').toLowerCase())
        },
        saveBidder() {
            if (!this.currentBidder.adapter_type) {
                this.$notify({
                    group: 'ops',
                    type: 'error',
                    title: 'Validation Error',
                    text: 'Adapter type is required.'
                })
                return
            }

            // A blank id is not a harmless empty row. Prebid Server validates the
            // bidder params and answers a missing required field with HTTP 400 on
            // the entire auction, so one unfilled bidder takes down every other
            // bidder's demand for that player. Refuse to save it.
            const spec = paramSpecFor(this.currentBidder.adapter_type)
            if (!String(this.currentBidder.paramValue || '').trim()) {
                this.$notify({
                    group: 'ops',
                    type: 'error',
                    title: 'Validation Error',
                    text: spec.label + ' is required for ' + this.currentBidder.adapter_type
                        + '. Saving it blank makes Prebid Server reject the whole auction.'
                })
                return
            }

            // Initialize header_bidding if null
            if (!this.header_bidding) {
                this.header_bidding = {
                    id: null,
                    enabled: true,
                    timeout: 3000,
                    dfp_network_id: '',
                    dfp_ad_unit: '',
                    bidders: []
                }
            }
            if (!this.header_bidding.bidders) {
                this.header_bidding.bidders = []
            }
            
            // Force is_s2s=false for bidders known to have no PBS adapter, regardless
            // of what the user toggled (defensive — also locked at the UI level).
            const code = this.currentBidder.adapter_type
            const isS2s = this.isClientSideOnlyBidder(code)
                ? false
                : this.currentBidder.is_s2s !== false

            // Write the value under the key THIS adapter requires. Getting it wrong
            // makes PBS 400 the entire auction, taking every other bidder with it.
            const params = {}
            params[paramSpecFor(code).key] = this.currentBidder.paramValue
            if (this.currentBidder.test) params.test = 1

            if (this.editingBidderIndex !== null) {
                // Update existing bidder
                this.$set(this.header_bidding.bidders, this.editingBidderIndex, {
                    name: this.currentBidder.name || code,
                    adapter_type: code,
                    params,
                    is_s2s: isS2s
                })
            } else {
                // Add new bidder
                if (!this.header_bidding.bidders) {
                    this.$set(this.header_bidding, 'bidders', [])
                }
                this.header_bidding.bidders.push({
                    name: this.currentBidder.name || code,
                    adapter_type: code,
                    params,
                    is_s2s: isS2s
                })
            }
            
            // Save to API immediately
            this.updateHeaderBidding()
            this.closeBidderModal()
        },
        deleteBidder() {
            if (this.editingBidderIndex !== null && this.header_bidding && this.header_bidding.bidders) {
                var reply = confirm('Are you sure you want to remove this Bidder?')
                if (!reply) return
                
                this.header_bidding.bidders.splice(this.editingBidderIndex, 1)
                // Save to API immediately
                this.updateHeaderBidding()
                this.closeBidderModal()
            }
        },
        closeBidderModal() {
            $('#BidderModal').modal('hide')
            this.currentBidder = { name: '', adapter_type: '', paramValue: '', is_s2s: true, test: false }
            this.editingBidderIndex = null
        },
        addBidder() {
            if (!this.header_bidding) {
                this.header_bidding = {
                    id: null,
                    enabled: true,
                    timeout: 3000,
                    dfp_network_id: '',
                    dfp_ad_unit: '',
                    bidders: []
                }
            }
            if (!this.header_bidding.bidders) {
                this.$set(this.header_bidding, 'bidders', [])
            }
            this.header_bidding.bidders.push({
                name: '',
                params: { placementId: '' }
            })
        },
        removeBidder(index) {
            var reply = confirm('Are you sure you want to remove this Bidder?')
            if (!reply) return
            if (!this.header_bidding || !this.header_bidding.bidders) return
            this.header_bidding.bidders.splice(index, 1)
            // Save to API immediately
            this.updateHeaderBidding()
        },
        update() {
            this.updateMonetization()
            this.updateSchedule()
            this.updateHeaderBidding()
            this.updateAdCrewSettings()
        },
        updateAdCrewSettings() {
            if (!this.adcrew_settings || !this.adcrew_settings.id) return

            AdCrewSettingsRepo.patch(this.adcrew_settings.id, {
                disable_non_linear: !!this.adcrew_settings.disable_non_linear,
                full_slot_ad_mode: !!this.adcrew_settings.full_slot_ad_mode
            }).then(result => {
                this.$set(this.adcrew_settings, 'disable_non_linear', !!result.data.disable_non_linear)
                this.$set(this.adcrew_settings, 'full_slot_ad_mode', !!result.data.full_slot_ad_mode)
            }).catch(error => {
                this.$notify({
                    group: 'ops',
                    type: 'error',
                    title: 'Operation failed',
                    text: 'Failed to update non-linear ads setting.'
                })
            })
        },
        updateMonetization() {
            const payload = {
                monetize: this.monetization.monetize,
                disable_player_ad_block: this.monetization.disable_player_ad_block,
                disable_autoplay_ad_block: this.monetization.disable_autoplay_ad_block,
                ad_sources: this.adSources,
                exchange_tag_id: this.monetization.exchange_tag_id || ''
            }

            MonetizationRepo.patch(this.monetization.id, payload).then(result => {
                this.$notify({
                    group: 'ops',
                    type: 'success',
                    title: 'Operation success',
                    text: 'Successfully updated monetization.'
                })
            }).catch(error => {
                this.$notify({
                    group: 'ops',
                    type: 'error',
                    title: 'Operation failed',
                    text: 'Failed update monetization.'
                })
            })
        },
        updateHeaderBidding() {
            // Don't update if header_bidding is null (not initialized)
            if (!this.header_bidding) return
            
            // Parse the textarea JSON mirrors. Invalid JSON falls back to the
            // previously-saved object so a typo doesn't blow away saved config.
            const parseOrKeep = (text, fallback) => {
                if (!text || !text.trim()) return null
                try { return JSON.parse(text) } catch (_) { return fallback }
            }
            const payload = {
                enabled: this.header_bidding.enabled || false,
                timeout: this.header_bidding.timeout || 3000,
                dfp_network_id: this.header_bidding.dfp_network_id || '',
                dfp_ad_unit: this.header_bidding.dfp_ad_unit || '',
                account_id: this.header_bidding.account_id || '1',
                prebid_url: this.header_bidding.prebid_url || '',
                schain_sid: (this.header_bidding.schain_sid || '').trim(),
                price_granularity: this.header_bidding.price_granularity || 'medium',
                consent_management: parseOrKeep(this.consent_management_text, this.header_bidding.consent_management),
                custom_targeting: parseOrKeep(this.custom_targeting_text, this.header_bidding.custom_targeting),
                debug: this.header_bidding.debug === true,
                bidders: (this.header_bidding.bidders || []).map(b => {
                    const code = b.adapter_type || b.name
                    return {
                        name: b.name || code,
                        adapter_type: code,
                        params: b.params || { placementId: '' },
                        // Persist routing. The backend deletes+recreates bidders on every
                        // save and defaults is_s2s to true when it's omitted, so without
                        // this a client-side bidder (e.g. eskimi) flips to server-side on
                        // the next save. Force client-side for no-PBS-adapter bidders;
                        // otherwise honor the stored flag (default server-side).
                        is_s2s: this.isClientSideOnlyBidder(code) ? false : (b.is_s2s !== false)
                    }
                })
            }

            if (this.header_bidding.id) {
                // Update existing header bidding
                this.patchHeaderBidding(this.header_bidding.id, payload)
            } else {
                // Check if header bidding already exists for this player
                HeaderBiddingRepo.getByPlayer(this.monetization.player).then(result => {
                    if (result.data.results && result.data.results.length > 0) {
                        // Header bidding exists, update it
                        const existingId = result.data.results[0].id
                        this.header_bidding.id = existingId
                        this.patchHeaderBidding(existingId, payload)
                    } else {
                        // Create new header bidding
                        payload.player = this.monetization.player
                        HeaderBiddingRepo.post(payload).then(result => {
                            this.header_bidding = result.data
                            this.$notify({
                                group: 'ops',
                                type: 'success',
                                title: 'Operation success',
                                text: 'Successfully created header bidding.'
                            })
                        }).catch(error => {
                            this.$notify({
                                group: 'ops',
                                type: 'error',
                                title: 'Operation failed',
                                text: 'Failed to create header bidding.'
                            })
                        })
                    }
                }).catch(error => {
                    // If query fails, try to create anyway
                    payload.player = this.monetization.player
                    HeaderBiddingRepo.post(payload).then(result => {
                        this.header_bidding = result.data
                        this.$notify({
                            group: 'ops',
                            type: 'success',
                            title: 'Operation success',
                            text: 'Successfully created header bidding.'
                        })
                    }).catch(error => {
                        this.$notify({
                            group: 'ops',
                            type: 'error',
                            title: 'Operation failed',
                            text: 'Failed to create header bidding.'
                        })
                    })
                })
            }
        },
        patchHeaderBidding(id, payload) {
            HeaderBiddingRepo.patch(id, payload).then(result => {
                this.header_bidding = result.data
                this.$notify({
                    group: 'ops',
                    type: 'success',
                    title: 'Operation success',
                    text: 'Successfully updated header bidding.'
                })
            }).catch(error => {
                this.$notify({
                    group: 'ops',
                    type: 'error',
                    title: 'Operation failed',
                    text: 'Failed to update header bidding.'
                })
            })
        },
        // Normalize schedule payload to match backend expectations
        normalizeIdsList(list) {
            if (!list) return []
            return list.map(el => (el && el.id) ? el.id : el).filter(el => typeof el === 'number')
        },
        getScalarId(value) {
            if (!value) return null
            if (typeof value === 'number') return value
            if (Array.isArray(value)) return value.length ? (value[0] && value[0].id ? value[0].id : value[0]) : null
            return value.id || null
        },
        updateSchedule() {
            const schedule = this.monetization.schedule
            const payload = {
                type: schedule.type,
                preroll: this.normalizeIdsList(schedule.preroll),
                midroll: this.normalizeIdsList(schedule.midroll),
                postroll: this.normalizeIdsList(schedule.postroll),
                multiple_vast: this.normalizeIdsList(schedule.multiple_vast),
                vast: this.getScalarId(schedule.vast),
                display_banner: this.getScalarId(schedule.display_banner)
            }
            SchedulesRepo.patch(schedule.id, payload).then(result => {
                this.$notify({
                    group: 'ops',
                    type: 'success',
                    title: 'Operation success',
                    text: 'Successfully updated schedule.'
                })
            }).catch(error => {
                this.$notify({
                    group: 'ops',
                    type: 'error',
                    title: 'Operation failed',
                    text: 'Failed updated schedule.'
                })
            })

        },
        onScheduleDelete(type) {
            switch (type) {
                case 'preroll':
                    this.isPreroll = false
                    this.monetization.schedule.preroll = []
                    break
                
                case 'midroll':
                    this.isMidroll = false
                    this.monetization.schedule.midroll = []
                    break
                
                case 'postroll':
                    this.isPostroll = false
                    this.monetization.schedule.postroll = []
                    break
                
                case 'display_banner':
                    this.isDisplayBanner = false
                    this.monetization.schedule.display_banner = null
                    break

                case 'vast':
                    this.isVast = false
                    this.monetization.schedule.vast = null
                    break
                
                case 'multiple_vast':
                    this.isMultipleVast = false
                    this.monetization.schedule.multiple_vast = []
                    break
            }
            // this.updateSchedule()
        },
        onScheduleChanged(selection) {
            switch (selection.type) {
                case 'preroll':
                    this.monetization.schedule.preroll = selection.data
                    break
                
                case 'midroll':
                    this.monetization.schedule.midroll = selection.data
                    break
                
                case 'postroll':
                    this.monetization.schedule.postroll = selection.data
                    break
                
                case 'display_banner':
                    if (selection.data && selection.data.id) {
                        this.monetization.schedule.display_banner = selection.data.id
                        break
                    }
                    // When cleared, set to null
                    this.monetization.schedule.display_banner = (Array.isArray(selection.data) && selection.data.length)
                        ? selection.data[0]
                        : null
                    break

                case 'vast':
                    if (selection.data && selection.data.id) {
                        this.monetization.schedule.vast = selection.data.id
                        break
                    }
                    // When cleared, set to null
                    this.monetization.schedule.vast = (Array.isArray(selection.data) && selection.data.length)
                        ? selection.data[0]
                        : null
                    break
                
                case 'multiple_vast':
                    this.monetization.schedule.multiple_vast = selection.data
                    break
            }
            // this.updateSchedule()
        }
    },
    watch: {
        '$route.query.website': { 
            handler: function (website) {
                if(typeof website !== 'undefined') {
                    // check if user is not loaded 
                    // website placements_groups before
                    if(this.website_id !== website) {
                        // match website with passed from query
                        this.website_id = website
                    }
                } else {
                    this.$router.push({name: "website"})
                }
            },
            deep: true,
            immediate: true
        },
        'monetization.player': {
            handler: function (player) {
                if (player) {
                    this.initAdSources()
                    this.loadHeaderBidding()
                }
            },
            immediate: true
        }
    }
}
</script>